// ChatHighlight — catálogo de presets visuales por `type` (feat_116 v2).
// IDENTIDAD VISUAL del sistema, HARDCODEADA: NO configurable por cliente.
// Tres niveles de intensidad; cada `type` referencia un nivel. Sumar un consumidor
// nuevo = una línea en HIGHLIGHT_PRESETS. La CSS de cada nivel vive en el useStyles de
// TicketListItem (clases hl_soft / hl_medium / hl_strong + keyframes), porque @keyframes
// no se puede inline. Acá solo el mapa lógico (nivel, ícono, tooltip, latido del ícono).
//
// Niveles:
//   soft   (default types desconocidos) → pulso lento, color tenue, borde fino.
//   medium (atención firme)             → ámbar saturado, pulso ~1.3s, borde grueso.
//   strong (urgente / oportunidad)      → verde intenso, pulso ~1s, borde grueso + ícono late.

export const LEVEL_ACCENT = {
	soft: "#ff9800",
	medium: "#ff6f00",
	strong: "#00c853",
};

export const HIGHLIGHT_PRESETS = {
	cart_abandoned: {
		level: "medium",
		icon: "⚠",
		tooltipKey: "chatHighlight.needsAttention",
		iconPulse: false,
	},
	// Preparado para Fase 5 de MatchProp (oportunidad → verde fuerte).
	matchprop: {
		level: "strong",
		icon: "🎯",
		tooltipKey: "chatHighlight.matchprop",
		iconPulse: true,
	},
};

export const DEFAULT_PRESET = {
	level: "soft",
	icon: "⚠",
	tooltipKey: "chatHighlight.needsAttention",
	iconPulse: false,
};

export const getHighlightPreset = type =>
	HIGHLIGHT_PRESETS[type] || DEFAULT_PRESET;
